import { View, Image, StyleSheet, Text } from "@react-pdf/renderer";
import React from "react";
import advenioLogo from "../../../images/advenio-logo.png";
import { useSelector } from "react-redux";
import moment from "moment";
const styles = StyleSheet.create({
  headerContainer: {
    position: "fixed",
    width: "100%",
    top: 0,
    // height: 50,
    left: 0,
  },
  logContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  logo: {
    width: 170,
  },
  line: {
    borderBottomColor: "#ad3919",
    borderBottomWidth: 1.5,
    marginVertical: 10,
  },
  row: {
    flexDirection: "row",
    textAlign: "left",
    width: "100%",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  image: {
    width: "20%",
    textAlign: "left",
    padding: "10px",
    fontSize: "12px",
  },
  patientName: {
    width: "30%",
    textAlign: "left",
    padding: "10px",
    fontSize: "12px",
  },
  status: {
    width: "50%",
    textAlign: "left",
    padding: "10px",
    fontSize: "12px",
  },
});
const Header = ({ orgzName,orzLogoUrl }) => {
  let clientLogo = orzLogoUrl;
  return (
    <View style={styles.headerContainer}>
      <View style={styles.logContainer}>
        {clientLogo&&<View>
          <Image style={styles.logo} source={clientLogo} />
        </View>}
        <View>
          <Image style={styles.logo} source={advenioLogo} />
        </View>
      </View>
      <View style={styles.line} />
      <View>
        <View style={styles.logContainer}>
          <View
            style={{
              textAlign: "left",
              float: "left",
              width: "50%",
              fontSize: "12px",
            }}
          >
            <Text>Site Name :{orgzName} </Text>
          </View>
          <View
            style={{
              textAlign: "right",
              float: "right",
              fontSize: "12px",
              width: "50%",
            }}
          >
            <Text>
              Printed on: {moment(new Date()).format("DD-MM-YYYY hh:mmA")}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.line} />

      <View style={styles.row}>
        <Text style={styles.patientName}>Patient Details</Text>
        <Text style={styles.image}>Images</Text>
        <Text style={styles.status}>Status</Text>
      </View>

      <View style={styles.line} />
    </View>
  );
};

export default Header;
